import { render, staticRenderFns } from "./MyPlans.vue?vue&type=template&id=ea28b39a&scoped=true"
import script from "./MyPlans.vue?vue&type=script&lang=ts"
export * from "./MyPlans.vue?vue&type=script&lang=ts"
import style0 from "./MyPlans.vue?vue&type=style&index=0&id=ea28b39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea28b39a",
  null
  
)

export default component.exports